<template>

    <button class="btn btn-white" :class="classes" :style="styles" :disabled="loading || disabled">
        <v-loader v-if="loading" size="sm" />
        <i v-else :class="active ? (activeIcon ?? icon) : icon" :style="iconStyles" />
    </button>

</template>

<style scoped lang="scss">

    .btn {
        align-items: center;
        appearance: none;
        border: none;
        box-shadow: none;
        cursor: pointer;
        display: flex;
        flex-grow: 0;
        justify-content: center;
        margin: 0;
        outline: none;
        overflow: hidden;
        padding: 0;
        text-decoration: none;
        transition: border-color .3s;
        text-align: center;
        text-decoration: none;
        user-select: none;
        i {
            transition: opacity .3s;
        }
        &:disabled {
            cursor: default;
            opacity: 1;
            i {
                opacity: 0.5;
            }
        }
        &.btn-sm {
            border-radius: 5px;
            font-size: 14px;
        }
        &.btn-md {
            border-radius: 5px;
            font-size: 14px;
        }
        &.btn-white {
            background-color: $color-white;
            border: 1px solid $color-rule;
            color: $color-text;
            &:focus {
                background-color: $color-white;
                border: 1px solid $color-rule;
                color: $color-text;
            }
            &:hover, &:active {
                background-color: $color-white;
                border: 1px solid $color-text;
                color: $color-text;
            }
            &.active {
                color: $color-primary;
            }
        }
    }

</style>

<script>

export default {

    props: {
        active: {
            type: Boolean,
            default: false,
        },
        activeIcon: {
            type: String,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        height: {
            type: String,
            default: '40px',
        },
        icon: {
            required: true,
            type: String,
        },
        iconSize: {
            type: String,
            default: null,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        size: {
            type: String,
            default: 'sm',
        },
        width: {
            type: String,
            default: '40px',
        },
    },

    computed: {

        classes() {
            return {
                'btn-sm': this.size === 'sm',
                'btn-md': this.size === 'md',
                'active': this.active,
            };
        },

        iconStyles() {
            if (!this.iconSize) {
                return null;
            }

            return {
                'font-size': this.iconSize,
            };
        },

        styles() {
            return {
                'height': this.height,
                'width': this.width,
                'flex-shrink': this.width.toString().endsWith('px') ? 0 : 1,
            };
        },

    },

}

</script>